import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import Scroll from "react-scroll";
import Ink from "react-ink";
import ReactGA from "react-ga";
import {
  FacebookShareButton,
  TwitterShareButton,
  PinterestShareButton,
} from "react-share";

import { getWindowScrollTop } from "../helpers";
import MenuPortal from "./MenuPortal";
import ShareViaEmailPortal from "./ShareViaEmailPortal";

class NavigationContainer extends Component {
  constructor() {
    super();

    this.state = {
      mobileMenuOpened: false,
      shareViaEmailOpened: false,
      menuBtnClass: "menu-btn",
      renderArray: [],
    };

    this.navItemClick = this.navItemClick.bind(this);
    this.mobileMenuBtnClick = this.mobileMenuBtnClick.bind(this);
    this.showMailFormClick = this.showMailFormClick.bind(this);
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.onScroll, false);
  };

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.onScroll, false);
  };

  onScroll = () => {
    if (getWindowScrollTop() > 80) {
      this.setState({ menuBtnClass: "menu-btn fixed" });
    } else {
      this.setState({ menuBtnClass: "menu-btn" });
    }
  };

  mobileMenuBtnClick(value) {
    this.setState({ mobileMenuOpened: value });
  }

  showMailFormClick(value) {
    if (this.state.mobileMenuOpened) {
      this.setState({ mobileMenuOpened: false }, () => {
        setTimeout(() => {
          this.setState({ shareViaEmailOpened: value });
        }, 500);
      });
    } else {
      this.setState({ shareViaEmailOpened: value });
    }
  }

  navItemClick(name) {
    // ReactGA.event({
    //     category: 'navigation',
    //     action: `click ${name}`
    // });

    Scroll.animateScroll.scrollTo(
      document.getElementById(name).getBoundingClientRect().top +
        getWindowScrollTop()
    );
    this.setState({ mobileMenuOpened: false });
  }

  setComponets(
    videoBlock,
    matterportBlock,
    floorplanBlock,
    threeDModelBlock,
    photosBlock,
    detailsBlock,
    documentsBlock,
    presentedByBlock,
    locationBlock,
    claimHomeBlock
  ) {
    // {videoBlock}
    //                 {matterportBlock}
    //                 {floorplanBlock}
    //                 {threeDModelBlock}
    //                 {photosBlock}
    //                 {detailsBlock}
    //                 {documentsBlock}
    //                 {presentedByBlock}
    //                 {locationBlock}
    //                 {claimHomeBlock}
    // ['Photos', 'SlideVideo', 'Video', 'Matterport', 'FloorPlan', 'Flyers', 'Documents', 'Features', 'Map', 'ClaimHome', 'Contacts', 'Description']
    const res = [];
    this.props.componentsArray.forEach((el) => {
      switch (el) {
        case "Photos":
          res.push(photosBlock);
          break;
        case "SlideVideo":
          res.push(videoBlock);
          break;
        // case "Video":
        //   res.push(<VideoContainer />);
        //   break;
        case "Matterport":
          res.push(matterportBlock);
          break;
        case "FloorPlan":
          res.push(floorplanBlock);
          break;
        case "Features":
          res.push(detailsBlock);
          break;
        case "Map":
          res.push(locationBlock);
          break;
        case "ClaimHome":
          res.push(claimHomeBlock);
          break;
        case "Contacts":
          res.push(presentedByBlock);
          break;
        case "Flyers":
          res.push(documentsBlock);
          break;
        case "FloorPlan3D":
          res.push(threeDModelBlock);
          break;
        // case "Listing":
        //   res.push(<ListingsContainer />);
        //   break;
        // case "Description":
        //   res.push(<DescriptionContainer />);
        //   break;
        default:
          break;
      }
    });
    return res;
  }

  render() {
    const {
      logo,
      buttonsVisibility,
      galleryBtnVisible,
      logoHref,
      agentEmail,
      backgroundPhoto,
      logoTime,
      tourType,
      matterport,
    } = this.props;

    // const { FacebookShareButton, TwitterShareButton, PinterestShareButton } =
    //   ShareButtons;

    const createBlock = (title, visibility, name) =>
      visibility ? (
        <li>
          <span name={name} onClick={() => this.navItemClick(name)}>
            {title}
          </span>
        </li>
      ) : null;

    const photosBlock = createBlock("photos", galleryBtnVisible, "gallery");

    const matterportBlock = createBlock(
      matterport.matterportTitle,
      buttonsVisibility.matterportBtnVisible,
      "matterport"
    );
    const floorplanBlock = createBlock(
      "floor plan",
      buttonsVisibility.floorplanBtnVisible,
      "floorplan"
    );
    const threeDModelBlock = createBlock(
      "3d floor plan",
      buttonsVisibility.threeDModelBtnVisible,
      "threeDModel"
    );

    const videoBlock = buttonsVisibility.videoBtnVisible
      ? createBlock("video", buttonsVisibility.videoBtnVisible, "video")
      : createBlock("video", buttonsVisibility.walkthruBtnVisible, "walkthru");

    const detailsBlock = buttonsVisibility.descriptionBtnVisible
      ? createBlock(
          "details",
          buttonsVisibility.descriptionBtnVisible,
          "description"
        )
      : createBlock(
          "details",
          buttonsVisibility.propertyDetailsBtnVisibility,
          "details"
        );

    const documentsBlock = createBlock(
      "documents",
      buttonsVisibility.documentsBtnVisibility,
      "documents"
    );

    const presentedByBlock = createBlock(
      "presented by",
      buttonsVisibility.presentedByBtnVisibility,
      "contact"
    );

    const locationBlock = createBlock(
      "location",
      buttonsVisibility.locationBtnVisibility,
      "location"
    );

    const claimHomeBlock = createBlock(
      "claim home",
      buttonsVisibility.claimHomeBtnVisibility,
      "claimHome"
    );

    const logoLink =
      logoHref && logoHref.indexOf("http") !== 0
        ? "//".concat(logoHref)
        : logoHref;

    const logoBlock = logo.length ? (
      <a target="_blank" href={logoLink ? logoLink : logo}>
        <img src={logo + "?h=80&w=160&logoTime=" + logoTime} alt="logo" />
      </a>
    ) : null;

    const contactBtnBlock = agentEmail.length ? (
      <li>
        <button
          className="btn"
          onClick={() => this.navItemClick("contact")}
          name="contact"
        >
          contact
          <Ink />
        </button>
      </li>
    ) : null;

    const facebookBtn =
      tourType == "branded" ? (
        <li>
          <FacebookShareButton
            url={window.location.toString()}
            quote="share to facebook"
          >
            <button className="btn btn-transparent">
              <Ink />
              <i className="fa fa-facebook" aria-hidden="true"></i>
            </button>
          </FacebookShareButton>
        </li>
      ) : null;

    const pinterestBtn =
      tourType == "branded" ? (
        <li>
          <PinterestShareButton
            url={window.location.toString()}
            media={backgroundPhoto ? backgroundPhoto.file : ""}
            windowWidth={1000}
            windowHeight={730}
          >
            <button className="btn btn-transparent">
              <Ink />
              <i className="fa fa-pinterest-p" aria-hidden="true"></i>
            </button>
          </PinterestShareButton>
        </li>
      ) : null;

    const twitterBtn =
      tourType == "branded" ? (
        <li>
          <TwitterShareButton
            url={window.location.toString()}
            title="share to twitter"
          >
            <button
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="btn btn-transparent"
            >
              <Ink />
              {/* <i className="fa fa-twitter" aria-hidden="true"></i>
               */}
              <svg
                style={{
                  width: 36,
                  paddingTop: 5
                }}
                xmlns="http://www.w3.org/2000/svg"
                shape-rendering="geometricPrecision"
                text-rendering="geometricPrecision"
                image-rendering="optimizeQuality"
                fill-rule="evenodd"
                clip-rule="evenodd"
                viewBox="0 0 512 462.799"
              >
                <path
                  fill-rule="nonzero"
                  fill="#fff"
                  d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z"
                />
              </svg>
            </button>
          </TwitterShareButton>
        </li>
      ) : null;

    const shareBlock = buttonsVisibility.shareBtnVisible ? (
      <ul className="share-btns-list">
        {facebookBtn}
        {twitterBtn}
        {pinterestBtn}
        <li>
          <button
            className="btn btn-transparent"
            onClick={this.showMailFormClick}
          >
            <Ink />
            <i className="fa fa-envelope" aria-hidden="true"></i>
          </button>
        </li>
      </ul>
    ) : null;

    const btnArr = this.setComponets(
      videoBlock,
      matterportBlock,
      floorplanBlock,
      threeDModelBlock,
      photosBlock,
      detailsBlock,
      documentsBlock,
      presentedByBlock,
      locationBlock,
      claimHomeBlock
    );

    return (
      <header className="navigation-component">
        <div className="logo-wrapper">{logoBlock}</div>
        <nav className="navigation-wrapper">
          <ul>
            {btnArr}
            {/* {videoBlock}
                        {matterportBlock}
                        {floorplanBlock}
                        {threeDModelBlock}
                        {photosBlock}
                        {detailsBlock}
                        {documentsBlock}
                        {presentedByBlock}
                        {locationBlock}
                        {claimHomeBlock} */}
          </ul>
        </nav>
        <div className={this.state.menuBtnClass}>
          <button
            className="btn"
            onClick={() => {
              this.mobileMenuBtnClick(true);
            }}
          >
            <Ink />
            menu
          </button>
        </div>
        <ShareViaEmailPortal
          btnClick={this.showMailFormClick}
          isOpened={this.state.shareViaEmailOpened}
        ></ShareViaEmailPortal>
        <MenuPortal
          btnClick={this.mobileMenuBtnClick}
          isOpened={this.state.mobileMenuOpened}
        >
          <ul>
            {btnArr}
            {/* {videoBlock}
                        {matterportBlock}
                        {floorplanBlock}
                        {threeDModelBlock}
                        {photosBlock}
                        {detailsBlock}
                        {documentsBlock}
                        {presentedByBlock}
                        {locationBlock}
                        {claimHomeBlock} */}
            {shareBlock}
            {contactBtnBlock}
          </ul>
        </MenuPortal>
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    logoTime: state.agent.agentInfo.logoTime,
    logo: state.agent.agentInfo.logo,
    logoHref: state.agent.agentInfo.orig_website,
    buttonsVisibility: state.app.buttonsVisibility,
    galleryBtnVisible: state.gallery.galleryBtnVisible,
    agentEmail: state.agent.agentInfo.email,
    backgroundPhoto: state.app.backgroundPhoto,
    tourType: state.app.tourType,
    matterport: state.matterport,
    componentsArray: state.app.componentsArray,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationContainer);
